import type { Messages } from './en';

/** Fase A: el passaport d'anglès i el tutorial de la primera partida. */
export const caGuide: Pick<Messages, 'passport' | 'tutorial'> = {
  passport: {
    title: "🛂 Passaport d'anglès",
    tool: 'Passaport',
    levels: ['Principiant', 'A1 Explorador', 'A2 Viatger', 'B1 Parlant', 'B1+ Estrella', 'B2 Campió'],
    xp: (n: number) => `${n} XP`,
    next: (n: number) => `${n} XP per al nivell següent`,
    top: 'Has arribat al nivell màxim, increïble!',
    levelUp: (name: string) => `🎉 Nou nivell d'anglès: ${name}!`,
    newStamp: "🛂 Nou segell al teu passaport d'anglès!",
    stats: {
      known: 'Paraules vistes',
      mastered: 'Dominades',
      spelled: 'Lletrejades',
      shadowed: 'Dites en veu alta',
      talks: 'Diàlegs',
      stories: 'Contes',
      stamps: 'Segells',
    },
    talkStamps: 'Segells de diàlegs',
    placeStamps: 'Llocs i festes',
    notYet: 'Encara no',
    week: 'Els teus últims dies',
    legend: { words: 'paraules', talks: 'diàlegs', spells: 'lletreig' },
    day: (n: number) => `D${n}`,
    parents: '👨‍👩‍👧 Per als grans',
    parentsHint: 'El que ha practicat el teu fill o filla. Les paraules de «continua practicant» tornen al repàs fins que queden apreses.',
    strong: 'Paraules fortes',
    weak: 'Continua practicant',
    none: 'Encara res',
    practise: "🎤 Vés al racó d'anglès",
    stampNames: {
      nightMarket: 'Mercat nocturn',
      lantern: 'Festa dels Fanalets',
      dragonBoat: 'Barques Drac',
      moon: 'Festa de la Lluna',
      newYear: 'Any Nou Xinès',
      taipei101: 'Taipei 101',
      mrt: 'Metro de Taipei',
      museum: 'Museu del Palau Nacional',
      taroko: 'Gorja de Taroko',
      beach: 'Platja de Qixingtan',
      jiufen: 'Carrer vell de Jiufen',
      xiangshan: "Muntanya de l'Elefant",
      ximen: "Ximending",
      longshan: "Temple de Longshan",
      cks: "Memorial de Chiang Kai-shek",
      beitou: "Termes de Beitou",
      dongdamen: "Mercat nocturn de Dongdamen",
      jian: "Ji'an",
    },
  },
  tutorial: {
    skip: 'Salta',
    next: 'Següent ›',
    back: '‹ Enrere',
    done: '▶ A jugar!',
    menu: '❓ Com es juga',
    steps: [
      { title: 'Benvinguda!', text: "Aquest és el teu poble a Taiwan. Viu els teus dies d'escola, ajuda la gent… i aprèn anglès pel camí." },
      { title: 'Passeja', text: 'Fes servir les fletxes o toca qualsevol punt del mapa per anar-hi caminant.' },
      { title: 'Parla i fes servir coses', text: "Quan siguis al costat d'algú o d'alguna cosa, aquest botó s'il·lumina. Toca'l per parlar, comprar, jugar…" },
      { title: 'Salta!', text: "Salta bardisses, tanques i arbustos. Alguns secrets només s'abasten d'un salt." },
      { title: 'Què toca ara', text: 'El teu proper objectiu sempre surt aquí, i una fletxa daurada al mapa et marca el camí.' },
      { title: 'El teu diari', text: 'Aquí hi ha els objectius d’avui, els capítols de la història i totes les missions. Qui porti un ❗ sobre el cap té alguna cosa per a tu.' },
      { title: 'El teu mòbil', text: 'Xats, trucades, PixelBook, la ràdio… i totes les eines: practicar anglès, la recreativa, la cerca del tresor, el passaport. Compte amb les estafes!' },
      { title: 'El menú', text: 'Aquí pots fer pausa, canviar la llengua, treure el so o desar la partida. Diverteix-te!' },
    ],
  },
};
